"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionId = void 0;
var localstorage_slim_1 = __importDefault(require("localstorage-slim"));
var nanoid_1 = require("nanoid");
function getSessionId() {
    // No need to try-catch, it's handled by localstorage-slim
    var sessionId = localstorage_slim_1.default.get('sessionId');
    if (!sessionId) {
        sessionId = (0, nanoid_1.nanoid)();
    }
    // 1 month TTL
    var ttl = 1000 * 60 * 60 * 24 * 30;
    localstorage_slim_1.default.set('sessionId', sessionId, { ttl: ttl });
    return sessionId;
}
exports.getSessionId = getSessionId;
